import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { gamesEndpointIds } from 'root/src/shared/games/games.constants';
export const resetGamesStatsQuotaEndpoint = {
    [gamesEndpointIds.RESET_GAMES_STATS_QUOTA]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
